import { InvoicingLevel } from "@flexidao/dto";

export const formatInvoicesLevel = (invoicesLevel: InvoicingLevel): string => {
    switch (invoicesLevel) {
        case InvoicingLevel.SiteLevel: {
            return "Site level";
        }
        case InvoicingLevel.ContractLevel: {
            return "Contract level";
        }
        default: {
            const exhaustiveCheck: never = invoicesLevel;

            throw new Error(`Unexpected invoice level ${exhaustiveCheck}`);
        }
    }
};
